import { motion } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';

interface RunningBehindBannerProps {
  driftMinutes: number;
  onDismiss: () => void;
}

export function RunningBehindBanner({ driftMinutes, onDismiss }: RunningBehindBannerProps) {
  return (
    <motion.div
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -50, opacity: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className="flex items-center gap-2 px-4"
      style={{
        height: '40px',
        background: 'rgba(251, 191, 36, 0.12)',
        borderBottom: '1px solid rgba(251, 191, 36, 0.3)',
      }}
    >
      <AlertTriangle size={16} style={{ color: 'var(--color-warning)', flexShrink: 0 }} />
      <span
        className="flex-1 text-[13px] font-semibold"
        style={{ color: 'var(--color-warning)' }}
      >
        Running ~{driftMinutes} min behind schedule
      </span>
      <button
        onClick={onDismiss}
        className="touch-target flex items-center justify-center"
        aria-label="Dismiss"
        style={{ minWidth: '28px', minHeight: '28px' }}
      >
        <X size={14} style={{ color: 'var(--color-warning)' }} />
      </button>
    </motion.div>
  );
}
